import { RouteObject } from "react-router-dom";
import { SIGN_IN_PATH, SignInPage } from "@/modules/auth/pages/sign-in";
import {
  FORGOT_PASSWORD_PATH,
  ForgotPasswordPage,
} from "@/modules/auth/pages/forgot-password";
import {
  RESET_PASSWORD_PATH,
  ResetPasswordPage,
} from "@/modules/auth/pages/reset-password";

export const authRoutes: RouteObject[] = [
  {
    path: SIGN_IN_PATH,
    element: <SignInPage />,
  },
  {
    path: FORGOT_PASSWORD_PATH,
    element: <ForgotPasswordPage />,
  },
  {
    path: RESET_PASSWORD_PATH,
    element: <ResetPasswordPage />,
  },
];
